import { Fragment } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'
import { RequestArchivedPipelinesModalRowActions } from '../RequestArchivedPipelinesModalRowActions'

import { renderCell } from './RequestArchivedPipelinesModalTableRow.utils'

import * as styles from './RequestArchivedPipelinesModalTableRow.module.css'

function RequestArchivedPipelinesModalTableRow({
  Actions = RequestArchivedPipelinesModalRowActions,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  hideCheckbox,
  isSelected,
  item,
  ...restProps
}) {
  const { handleMouseDown, handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ ...restProps, item })

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.RequestArchivedPipelinesModalTableRow,
    isSelected,
  })

  return (
    <div
      {...qaProps}
      className={className}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            item,
            name: column.name,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default RequestArchivedPipelinesModalTableRow
